import React, { useState, useEffect } from 'react';

const LoadingSpinner = ({ texto }) => {
    const [dots, setDots] = useState(3);

    useEffect(() => {
        const dotsInterval = setInterval(() => {
            setDots(prev => (prev >= 3 ? 0 : prev + 1));
        }, 500);

        return () => {
            clearInterval(dotsInterval);
        }
    }, []);

    return (
        <div className="modal-bg">
            <div className="loading-modal">
                <span className="loader"></span>
                {texto && <p>{texto}{".".repeat(dots)}</p>}
            </div>
        </div>
    );
}

export default LoadingSpinner;